import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import MainNav from "../Components/MainNav";
import Footer from "../Components/Footer";

// Gallery Images
import haveli1 from "../Images/ga3.jpg";
import haveli2 from "../Images/inter.jpg";
import haveli3 from "../Images/ga4.jpg";
import haveli4 from "../Images/goals.jpeg";
import haveli5 from "../Images/haveli5.jpg";
import haveli6 from "../Images/opentosky.jpg";
import haveli7 from "../Images/mesum.jpeg";
import haveli8 from "../Images/meu1.jpg";
import haveli9 from "../Images/h8.jpeg";
import haveli10 from "../Images/alfresco-views.jpg";
import haveli11 from "../Images/mix-fruit-punch.jpg";
import haveli12 from "../Images/photo0jpg.jpg";
import haveli13 from "../Images/view-of-badshahi-mosque.jpg";
import haveli14 from "../Images/this-is-the-view-of-badshahi.jpg";
import haveli15 from "../Images/exter.jpg";
import haveli16 from "../Images/ga1.jpg";

import newAerialRooftop from "../Images/new/aerial-rooftop-restaurant.jpg";
import newBadshahiLahore from "../Images/new/badshahi-overlooking-lahore.jpg";
import newBadshahiRooftopSunset from "../Images/new/badshahi-rooftop-sunset.jpg";
import newBadshahiNight from "../Images/new/badshahi-night.jpg";
import newTerraceDusk from "../Images/new/rooftop-terrace-dusk.jpg";
import newBadshahiAerial from "../Images/new/badshahi-aerial-rooftops.jpg";
import newHaveliBuilding from "../Images/new/haveli-building-aerial.jpg";
import newGoldenHour from "../Images/new/badshahi-golden-hour.jpg";
import newDawnToDusk from "../Images/new/lahore-dawn-to-dusk.jpg";
import newKebabFeast from "../Images/new/kebab-feast.jpg";
import newMixedGrill from "../Images/new/mughal-mixed-grill.jpg";
import newFloralHall from "../Images/new/floral-dining-hall.jpg";
import newTerraceDay from "../Images/new/rooftop-terrace-day.jpg";
import newBreakfast from "../Images/new/breakfast-badshahi.jpg";
import newSunsetDining from "../Images/new/sunset-dining-badshahi.jpg";
import newSunsetRooftop from "../Images/new/sunset-rooftop-dining.jpg";
import newCelebration from "../Images/new/twilight-rooftop-celebration.jpg";
import newWalledCity from "../Images/new/aerial-walled-city.jpg";
import newRooftopBazaar from "../Images/new/rooftop-bazaar.jpg";
import newRooftopDining from "../Images/new/rooftop-dining-city.jpg";

const galleryImages = [
  { img: newSunsetDining, title: "Sunset Dining Overlooking Badshahi Mosque", tag: "Rooftop" },
  { img: newHaveliBuilding, title: "Haveli Khalil Khan from Above", tag: "Architecture" },
  { img: newKebabFeast, title: "Lavish Chargrilled Kebab Feast", tag: "Culinary" },
  { img: newBadshahiNight, title: "Badshahi Mosque at Night", tag: "Iconic Vista" },
  { img: newFloralHall, title: "Ornate Floral Dining Hall", tag: "Interiors" },
  { img: newGoldenHour, title: "Golden Hour Over Badshahi Mosque", tag: "Twilight" },
  { img: newMixedGrill, title: "Midnight Mughal Mixed Grill Feast", tag: "Culinary" },
  { img: newCelebration, title: "Twilight Rooftop Celebration", tag: "Events" },
  { img: newBadshahiLahore, title: "Badshahi Mosque Overlooking Lahore", tag: "Walled City" },
  { img: newSunsetRooftop, title: "Sunset Rooftop Dining Over Historic Mosque", tag: "Rooftop" },
  { img: newBreakfast, title: "Scenic Breakfast Overlooking Badshahi Mosque", tag: "Breakfast" },
  { img: newTerraceDusk, title: "Bustling Rooftop Terrace at Dusk", tag: "Al Fresco" },
  { img: newBadshahiRooftopSunset, title: "Badshahi Mosque Rooftop at Sunset", tag: "Rooftop" },
  { img: newAerialRooftop, title: "Aerial Rooftop Restaurant View", tag: "Food Street" },
  { img: newTerraceDay, title: "Rooftop Terrace Dining Over the City", tag: "Al Fresco" },
  { img: newBadshahiAerial, title: "Badshahi Mosque & Food Street Rooftops", tag: "Walled City" },
  { img: newRooftopDining, title: "Vibrant Rooftop Dining Above the City", tag: "Rooftop" },
  { img: newRooftopBazaar, title: "Vibrant Rooftop Bazaar Over Lahore", tag: "Food Street" },
  { img: newWalledCity, title: "Aerial View of the Historic Walled City", tag: "Walled City" },
  { img: newDawnToDusk, title: "Lahore From Dawn to Dusk", tag: "Panorama" },
  { img: haveli13, title: "Badshahi Mosque Night Panorama", tag: "Iconic Vista" },
  { img: haveli1, title: "Rooftop Evening Ambiance", tag: "Al Fresco" },
  { img: haveli2, title: "Imperial Chamber Interiors", tag: "Mughal Heritage" },
  { img: haveli6, title: "Open Sky Starlight Dining", tag: "Rooftop" },
  { img: haveli10, title: "Historical Lahore Fort Views", tag: "Walled City" },
  { img: haveli15, title: "Historic Haveli Khalil Khan Facade", tag: "Architecture" },
  { img: haveli3, title: "Candlelit Evening Tables", tag: "Fine Dining" },
  { img: haveli4, title: "Courtyard Celebrations", tag: "Events" },
  { img: haveli5, title: "Heritage Balconies & Jharokas", tag: "Woodwork" },
  { img: haveli7, title: "Antiques & Mughal Relics", tag: "Museum Hall" },
  { img: haveli8, title: "Royal Feasts & Dining Sets", tag: "Imperial" },
  { img: haveli9, title: "Grand Banqueting Halls", tag: "Private Dining" },
  { img: haveli11, title: "Artisanal Beverages & Mocktails", tag: "Culinary" },
  { img: haveli12, title: "Night Illuminations", tag: "Food Street" },
  { img: haveli14, title: "Sunset Over Badshahi Domes", tag: "Twilight" },
  { img: haveli16, title: "Courtyard Garden Serenity", tag: "Haveli Garden" },
];

const PhotoGellary = () => {
  return (
    <div className="photo-galry-wrapper luxury-dark-page">
      <MainNav />

      {/* Hero Header */}
      <section className="luxury-page-hero text-center">
        <Container>
          <div className="luxury-pill-badge luxury-pill-badge--gold">
            <span>⚜ ARCHITECTURAL SPLENDOUR ⚜</span>
          </div>
          <h1 className="luxury-page-hero__title">The Haveli Gallery</h1>
          <p className="luxury-page-hero__subtitle">
            A visual journey through 25 years of Mughal craftsmanship, illuminated rooftop vistas of Badshahi Mosque, and unforgettable dining celebrations.
          </p>
        </Container>
      </section>

      {/* Responsive Luxury Multi-Column Grid */}
      <Container className="luxury-gallery-container pb-5">
        <Row className="g-4">
          {galleryImages.map((item, idx) => (
            <Col lg={4} md={6} sm={12} key={idx}>
              <div className="luxury-gallery-card">
                <div className="gallery-card-img-wrap">
                  <img 
                    src={item.img} 
                    alt={item.title} 
                    className="gallery-card-img" 
                    loading="lazy"
                  />
                  <div className="gallery-card-gradient" />
                </div>
                <div className="gallery-card-overlay">
                  <span className="gallery-card-tag">{item.tag}</span>
                  <h4 className="gallery-card-title">{item.title}</h4>
                  <div className="gallery-card-crest">⚜</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      <Footer />
    </div>
  );
};

export default PhotoGellary;